import React from 'react';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import { Router } from 'react-router';
import { change } from 'redux-form';
import { syncHistoryWithStore, routerMiddleware } from 'react-router-redux';
import { configureStore } from 'js-utils/redux';
import { getHistory, updateHistory } from 'js-utils/router';
import {
    middleware as analyticsMiddleware,
    GA_SETTINGS_PROP_TYPE,
} from '@eb/site-analytics';
import { HAS_WINDOW } from 'js-utils/feature-detection';

import { rootReducer as reducer } from './common/reducers/root';
import { initializeApp as initializeAppAction } from './common/actions';
import getRoutes from './page/routes';
import { LOOK_UP_FORM, SET_PASSWORD_FORM } from './common/constants';

/**** DO NOT COPY THIS PATTERN ****/
//This is needed so that if the user begins to type before the JS
//has finished loading we don't want the field to be cleared, instead
//we want the form to be initialized with that value so the user
//has a seamless experience, but is something we are going to be moving away from
//and will be refactored in the near future.
const _initializeFieldValues = (store) => {
    const emailField = document.getElementById('email');
    const passwordField = document.getElementById('set-password');
    let fieldValues = [];
    let form = LOOK_UP_FORM;

    if (emailField) {
        fieldValues = ['email', emailField.value];
    } else if (passwordField) {
        fieldValues = ['password', passwordField.value];
        form = SET_PASSWORD_FORM;
    }

    //Call change here since the onEnter hooks instantiate
    //the form and so to prevent overwriting the values we just
    //want to update the formField we care about.
    store.dispatch(change(form, ...fieldValues));
};

export default class AuthenticationApp extends React.PureComponent {
    static propTypes = {
        gaSettings: GA_SETTINGS_PROP_TYPE,
    };

    constructor(props) {
        super(props);

        const historyManagement = getHistory();
        const initialData = this._getInitialData();

        this._store = configureStore({
            reducer,
            middleware: [
                thunk,
                routerMiddleware(historyManagement),
                analyticsMiddleware(this.props),
            ],
        });
        this._history = syncHistoryWithStore(historyManagement, this._store);

        updateHistory(this._history, props.request);

        this._store.dispatch(initializeAppAction(initialData));
    }

    componentDidMount() {
        if (HAS_WINDOW) {
            _initializeFieldValues(this._store);
        }
    }

    componentWillReceiveProps(newProps) {
        updateHistory(this._history, newProps.request);
    }

    _getInitialData() {
        const {
            request,
            env,
            user,
            featureFlags: { consumerOnboarding },
            fp,
            recaptcha2PublicKey,
            recaptcha3PublicKey,
            gaSettings,
            socialSSOSettings,
            featureFlags,
            shouldIncludeEmailConfirmation,
            shouldShowAUSignUp,
        } = this.props;

        return {
            recaptcha2PublicKey,
            recaptcha3PublicKey,
            fp,
            gaSettings,
            socialSSOSettings,
            featureFlags,

            userTypeParams: {
                userType: request.params['user_type'],
                userTypeSig: request.params['user_type_sig'],
            },

            locale: env.localeInfo.locale,
            isAuthenticated: user.isAuthenticated,
            forward: request.params.forward || '',
            referrer: request.params.referrer || '',
            pckg: request.params.pckg || '',
            stld: request.params.stld || '',
            hasConsumerOnboarding: consumerOnboarding,
            shouldIncludeEmailConfirmation,
            shouldShowAUSignUp,
        };
    }

    render() {
        const { env, footerLinks, request, user } = this.props;

        const routes = getRoutes(
            {
                env,
                footerLinks,
                request,
                user,
            },
            this._store,
        );

        return (
            <Provider store={this._store}>
                <Router history={this._history} routes={routes} />
            </Provider>
        );
    }
}
